import { UnidadeNegocio } from '../unidade-negocio';

export class UnidadeNegocioPopula {
    selected: boolean;
    exists: boolean;
    unidadeNegocio: UnidadeNegocio;

    constructor(unidadeNegocio: UnidadeNegocio) {
        this.unidadeNegocio = unidadeNegocio;
    }
}
